// extracted by mini-css-extract-plugin
export var borderRadius = "_b0-4";
export var large = "_b0-3";
export var logoContainer = "_b0-0";
export var nameLogo = "_b0-2";
export var small = "_b0-1";